////////////////////////////////////////////////////////////
//  Program: booktourpayment.jsx                          //
//  Application: KINI HTML                                //
//  Option: Book Tour Payment                             //
//  Developer: PS		                                      //
//  Date: 2022-06-03                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import CommonHeader from "../common/CommonHeader";
import CommonFooter from "../common/CommonFooter";
import TextField from "@mui/material/TextField";
import CmsDataService from "../../services/CmsDataService";
import queryString from "query-string";
import Moment from "moment";
import ReservationService from "../../services/ReservationService";
import { Modal, Spinner } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import GooglePlaces from "../common/GooglePlaces";
import CountryService from "../../services/CountryService";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { ElementsConsumer } from "@stripe/react-stripe-js";
import { Datepicker, options, Page } from "@mobiscroll/react";
import CheckoutForm from "./CheckoutForm";
import { Helmet } from "react-helmet-async";
import CommonFooterNav from "../common/CommonFooterNav";
import { trackAdsEvent } from "../../../utils/marketingTracking";
const queryParams = queryString.parse(location.search);
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
class BookTourPayment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      personName: [],
      cityList: [],
      newCityList: [],
      cancelModal: false,
      selectedCityList: [],
      stateList: [],
      selectedStateList: [],
      input: localStorage.getItem("reservationDetails")
        ? JSON.parse(localStorage.getItem("reservationDetails"))
        : {},
      input: {},
      errors: {
        street_address_1: "",
        city: "",
        state_name: "",
        country: "",
        zipcode: "",
      },
      street_address_1: "",
      city: "",
      state_name: "",
      availableDate: "",
      country: "",
      zipcode: "",
      date: new Date("2014-08-18T21:11:54"),
      selectedDate: new Date(),
      type: false,
      value: undefined,
      inputValue: undefined,
      customer_id: localStorage.getItem("userData")
        ? localStorage.getItem("userData") == undefined ||
          localStorage.getItem("userData") == "[object Object]"
          ? localStorage.clear()
          : JSON.parse(localStorage.getItem("userData")).stripe_customer_id
        : {},
      property_name: localStorage.getItem("property_name")
        ? localStorage.getItem("property_name")
        : "",
      listing_slug: localStorage.getItem("listing_slug")
        ? localStorage.getItem("listing_slug")
        : queryParams.listing,
      clientToken: "",
      oldStartDate: localStorage.getItem("checkin")
        ? localStorage.getItem("checkin")
        : queryParams.checkin,
      oldEndDate: localStorage.getItem("checkout")
        ? localStorage.getItem("checkout")
        : queryParams.checkout,
      startDate: localStorage.getItem("checkin")
        ? localStorage.getItem("checkin")
        : queryParams.checkin,
      endDate: localStorage.getItem("checkout")
        ? localStorage.getItem("checkout")
        : queryParams.checkout,
      userToken: localStorage.getItem("userToken")
        ? localStorage.getItem("userToken")
        : undefined,
      nonce: "",
      total_selected_guest:
        (queryParams.numberOfAdults === undefined
          ? 1
          : parseInt(queryParams.numberOfAdults)) +
        (queryParams.numberOfChildren === undefined
          ? 0
          : parseInt(queryParams.numberOfChildren)),
      guest: 1,
      transactionData: "",
      first_name: localStorage.getItem("reservationDetails")
        ? JSON.parse(localStorage.getItem("reservationDetails")).first_name
        : "",
      last_name: localStorage.getItem("reservationDetails")
        ? JSON.parse(localStorage.getItem("reservationDetails")).last_name
        : "",
      email: localStorage.getItem("reservationDetails")
        ? JSON.parse(localStorage.getItem("reservationDetails")).email
        : "",
      guest_slug: localStorage.getItem("guest_slug")
        ? localStorage.getItem("guest_slug")
        : "",
      reservation_slug: localStorage.getItem("reservation_slug")
        ? localStorage.getItem("reservation_slug")
        : "",
      redirectToNextPage: false,
      phone_number: localStorage.getItem("reservationDetails")
        ? JSON.parse(localStorage.getItem("reservationDetails")).phone_number
        : "",
      old_phone_number: localStorage.getItem("reservationDetails")
        ? JSON.parse(localStorage.getItem("reservationDetails")).phone_number
        : "",
      displayPhoneNo: "",
      contryCode: localStorage.getItem("country_code_value")
        ? JSON.parse(localStorage.getItem("country_code_value"))
        : "",
      property_slug:
        props.match && props.match.params
          ? props.match.params.propertySlug
            ? props.match.params.propertySlug
            : global.property_slug
          : global.property_slug,
      queryString: "",
      adultCount:
        queryParams.numberOfAdults === undefined
          ? 1
          : parseInt(queryParams.numberOfAdults),
      childCount:
        queryParams.numberOfChildren === undefined
          ? 0
          : parseInt(queryParams.numberOfChildren),
      infantCount:
        queryParams.numberOfInfants === undefined
          ? 0
          : parseInt(queryParams.numberOfInfants),
      petsCount:
        queryParams.numberOfPets === undefined
          ? 0
          : parseInt(queryParams.numberOfPets),
      guestValue: "1 Guest",
      pricing: localStorage.getItem("pricing")
        ? JSON.parse(localStorage.getItem("pricing"))
        : {},
      // Selected fee slugs from URL — safe as identifiers; amounts are replaced by API in getAvailibityDate.
      additionalFees: queryParams.additionalFees ? queryParams.additionalFees : "",
      // Loaded only to pre-populate UI before the API responds; cost_price values here are untrusted.
      booking_addons: localStorage.getItem("booking_addons")
        ? JSON.parse(localStorage.getItem("booking_addons"))
        : { addon_total: 0, selected_addons_list: [] },
      street_address_1: localStorage.getItem("addressDetails")
        ? JSON.parse(localStorage.getItem("addressDetails")).street_address_1
        : "",
      street_address_2: localStorage.getItem("addressDetails")
        ? JSON.parse(localStorage.getItem("addressDetails")).street_address_2
        : "",
      city: localStorage.getItem("addressDetails")
        ? JSON.parse(localStorage.getItem("addressDetails")).city
        : "",
      state_name: localStorage.getItem("addressDetails")
        ? JSON.parse(localStorage.getItem("addressDetails")).state
        : "",
      country: localStorage.getItem("addressDetails")
        ? JSON.parse(localStorage.getItem("addressDetails")).contry
        : "",
      zipcode: localStorage.getItem("addressDetails")
        ? JSON.parse(localStorage.getItem("addressDetails")).zipcode
        : "",
      addressDetails: localStorage.getItem("addressDetails")
        ? JSON.parse(localStorage.getItem("addressDetails"))
        : "",
      loader: false,
      coupon_code: "",
      voucher_code: localStorage.getItem("applied_voucher_code")
        ? localStorage.getItem("applied_voucher_code")
        : "",
      voucher_discount: localStorage.getItem("applied_voucher_discount")
        ? parseFloat(localStorage.getItem("applied_voucher_discount")) || 0
        : 0,
      voucher_applied: localStorage.getItem("applied_voucher_code")
        ? true
        : false,
      voucher_error: "",
      voucher_loading: false,
      reservation_confirm: localStorage.getItem("reservation_confirm")
        ? localStorage.getItem("reservation_confirm")
        : "",
      isNeedtoStrDetails: false,
      headerToken: localStorage.getItem("headerToken")
        ? localStorage.getItem("headerToken")
        : "",
      userData: localStorage.getItem("userData")
        ? localStorage.getItem("userData") == undefined ||
          localStorage.getItem("userData") == "[object Object]"
          ? localStorage.clear()
          : JSON.parse(localStorage.getItem("userData"))
        : {},
      confirmation_code: localStorage.getItem("confirmation_code")
        ? localStorage.getItem("confirmation_code")
        : "",
      openPicker: false,
      additional_cost: [],
      listing_pet_allowed: 0,
      max_pets_allowed: 0,
      stripeIntentUpdating: false,
    };
    this._petDebounceTimer = null;
    this._pricingRequestId = 0;
    this._stripeRequestId = 0;
    this.handleChange = this.handleChange.bind(this);
    this.incrementAdult = this.incrementAdult.bind(this);
    this.decrementAdult = this.decrementAdult.bind(this);
    this.incrementchild = this.incrementchild.bind(this);
    this.decrementchild = this.decrementchild.bind(this);
    this.incrementinfant = this.incrementinfant.bind(this);
    this.decrementinfant = this.decrementinfant.bind(this);
    this.incrementpets = this.incrementpets.bind(this);
    this.decrementpets = this.decrementpets.bind(this);
    this.guestDetail = this.guestDetail.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.getclientToken = this.getclientToken.bind(this);
    this.checkAvailabilityDate = this.checkAvailabilityDate.bind(this);
    this.changeDateHandlerNew = this.changeDateHandlerNew.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDateChangeRange = this.handleDateChangeRange.bind(this);
  }

  getBookingInitiatedDedupeKey = () => {
    const listingSlug = this.state.listing_slug ? this.state.listing_slug : "";
    const checkIn = this.state.startDate
      ? Moment(this.state.startDate, ["MM/DD/YYYY", "YYYY-MM-DD"]).format(
          "YYYY-MM-DD",
        )
      : "";
    const checkOut = this.state.endDate
      ? Moment(this.state.endDate, ["MM/DD/YYYY", "YYYY-MM-DD"]).format(
          "YYYY-MM-DD",
        )
      : "";
    const reservationSlug = this.state.reservation_slug
      ? this.state.reservation_slug
      : "";

    if (!listingSlug || !checkIn || !checkOut) {
      return "";
    }

    return [reservationSlug, listingSlug, checkIn, checkOut]
      .filter(Boolean)
      .join("|");
  };

  trackBookingInitiatedOnce = () => {
    if (typeof window === "undefined") {
      return;
    }

    const dedupeKey = this.getBookingInitiatedDedupeKey();
    if (!dedupeKey) {
      return;
    }

    const storageKey = `ads_booking_initiated:${dedupeKey}`;
    if (window.sessionStorage.getItem(storageKey) === "1") {
      return;
    }

    trackAdsEvent("booking_initiated", {
      reservation_slug: this.state.reservation_slug || "",
      listing_slug: this.state.listing_slug || "",
      checkin_date: this.state.startDate || "",
      checkout_date: this.state.endDate || "",
    });

    window.sessionStorage.setItem(storageKey, "1");
  };

  async componentDidMount() {
    // Get a client token for authorization from your server
    this.getclientToken();
    this.checkAvailabilityDate();
    this.setState({
      guest: parseInt(localStorage.getItem("maximum_number_of_guests")),
    });
    this.guestDetail();
    this.setInputData();
    this.getGuestFormDetails();
    this.getWeekdayRules();
    this.getLorData();
    var ele = document.getElementById("phoneNumberFormat");
    var eleValue = this.state.phone_number;
    this.setState({ phone_number: eleValue });
    localStorage.setItem("queryParams", JSON.stringify(queryParams));
    if (this.state.reservation_confirm !== "") {
      this.props.history.push("/reservation-list");
      return;
    }

    // Treat reaching the payment page as booking initiation for paid traffic.
    this.trackBookingInitiatedOnce();
  }

  componentWillUnmount() {
    clearTimeout(this._petDebounceTimer);
  }

  callUpdateStripeIfReady = () => {
    const { stripe_id, pricing } = this.state;

    if (
      stripe_id &&
      stripe_id !== "" &&
      pricing &&
      pricing.total_listing_price_with_taxes_fees
    ) {
      this.UpdateStripeintent();
    }
  };

  // Helper to get weekday string from date
  getWeekdayStr(date) {
    const days = ["SU", "MO", "TU", "WE", "TH", "FR", "SA"];
    return days[new Date(date).getDay()];
  }

  async getWeekdayRules() {
    try {
      const dayMap = {
        Monday: "MO",
        Tuesday: "TU",
        Wednesday: "WE",
        Thursday: "TH",
        Friday: "FR",
        Saturday: "SA",
        Sunday: "SU",
      };
      let res = await ReservationService.getListingAvailabilityRule(
        "listing_slug=" + this.state.listing_slug,
      );

      if (global.successStatus.includes(res.status)) {
        if (res.data && res.data.length > 0) {
          const rules = res.data.reduce((acc, rule) => {
            const code = dayMap[rule.day_name];
            acc[code] = {
              checkin: rule.checkin_never_on ? 0 : 1,
              checkout: rule.checkout_never_on ? 0 : 1,
            };
            return acc;
          }, {});
          this.setState({ weekdayRules: rules });
        }
      }
    } catch (error) {
      console.error("Error fetching availability", error);
    }
  }

  async getLorData(queryString = "") {
    var lorList = [];
    var lorTotalRecords = 0;

    let res = await ReservationService.getListingLOR(
      "listing_slug=" +
        this.state.listing_slug +
        (queryString ? "&" + queryString : ""),
    );

    if (global.successStatus.includes(res.status)) {
      lorList = res.data ? res.data : [];
      lorTotalRecords = lorList.length ? lorList.length : 0;
    }

    this.setState({
      lorTotalRec: lorTotalRecords,
      lorRecord: lorList,
    });
  }

  getGuestFormDetails = async () => {
    this.setState({ showSpinner: true, loading: true });
    var totalRecords = 0;
    var list = [];
    var formSubmited = "";
    var cardTokenise = "";
    var is_card_enable = "";
    var confirmationcode = this.state.confirmation_code;
    let res = await ReservationService.getGuestformdata(confirmationcode);
    if (global.successStatus.includes(res.status)) {
      list = res.data ? res.data : [];
      totalRecords = list ? list.length : 0;
      formSubmited = res.data.is_form_submited ? res.data.is_form_submited : 0;
      cardTokenise = res.data.card_tokenise ? res.data.card_tokenise : 0;
      is_card_enable = res.data.is_card_enable ? res.data.is_card_enable : 0;
    }
    this.setState({
      is_form_submited: formSubmited,
      card_tokenise: cardTokenise,
      is_card_enable: is_card_enable,
      showSpinner: false,
      loading: false,
      total_record: totalRecords,
    });
    localStorage.setItem("is_form_submited", this.state.is_form_submited);
    localStorage.setItem("card_tokenise", this.state.card_tokenise);
    localStorage.setItem("card_enable", this.state.is_card_enable);
  };

  setInputData = () => {
    var first_name = this.state.input.first_name;
    var last_name = this.state.input.last_name;
    var email = this.state.input.email;
    var phone_number = this.state.input.phone_number;
    this.setState({
      first_name: first_name,
      last_name: last_name,
      email: email,
      phone_number: phone_number,
    });
  };

  cancelModal = async (value) => {
    this.setState({ cancelModal: value });
  };

  changeHandler = (event) => {
    let input = this.state.input;
    let value = event.target.value;

    if (event.target.name === "street_address_1") {
      if (event.target.value.length > 1) {
        var errors = this.state.errors;
        errors.street_address_1 = "";
        this.setState({ errors: errors });
      }
    }
    if (event.target.name === "zipcode") {
      if (event.target.value.length > 4) {
        var errors = this.state.errors;
        errors.zipcode = "";
        this.setState({ errors: errors });
      }
    }
    if (event.target.name === "city") {
      if (event.target.value.length > 1) {
        var errors = this.state.errors;
        errors.city = "";
        this.setState({ errors: errors });
      }
    }
    if (event.target.name === "state_name") {
      if (event.target.value.length > 1) {
        var errors = this.state.errors;
        errors.state_name = "";
        this.setState({ errors: errors });
      }
    }
    if (event.target.name === "country") {
      if (event.target.value.length > 1) {
        var errors = this.state.errors;
        errors.country = "";
        this.setState({ errors: errors });
      }
    }
    input[event.target.name] = value;
    this.setState({ [event.target.name]: value, input: input });
  };

  handleDateChangeRange = async (date, name) => {
    let input = this.state.input;
    input.move_in_date = Moment(new Date(date.value[0])).format("MM/DD/YYYY");
    input.move_out_date = Moment(new Date(date.value[1])).format("MM/DD/YYYY");
    await this.setState({
      startDate: input.move_in_date,
      endDate: input.move_out_date,
      input: input,
    });
  };

  setErrorFromCheckout(errors) {
    if (errors.street_address_1 === "") {
      errors.street_address_1 = "Street name is required.";
    }
    this.setState({ errors: errors });
  }

  clearLocalStorage = () => {
    localStorage.removeItem("pricing");
    localStorage.removeItem("checkin");
    localStorage.removeItem("checkout");
    localStorage.removeItem("guest_email");
    localStorage.removeItem("userToken");
    localStorage.removeItem("reservationDetails");
    localStorage.removeItem("listing_slug");
    localStorage.removeItem("listing_name");
    localStorage.removeItem("queryParams");
  };

  SaveTransactiondata = async (inputData) => {
    this.setState({ showSpinner: true, loading: true });
    var resData = {};
    var resDataArr = [];
    let res = await CmsDataService.saveTransaction(inputData);

    if (global.successStatus.includes(res.status)) {
      var address = this.state.street_address_1
        ? this.state.street_address_1 + ","
        : "";
      address += this.state.street_address_2
        ? this.state.street_address_2 + ","
        : "";
      address += this.state.country ? this.state.country + "," : "";
      address += this.state.state ? this.state.state + "," : "";
      address += this.state.zipcode ? this.state.zipcode + "." : "";

      var reservationData = {
        reservation_slug: this.state.reservation_slug,
        guest_slug: this.state.guest_slug,
        payment_status: 2,
        user_token: this.state.guest_slug,
        phone_number: this.state.phone_number,
        street_address_1: this.state.street_address_1
          ? this.state.street_address_1
          : "",
        street_address_2: this.state.street_address_2
          ? this.state.street_address_2
          : "",
        city: this.state.cityId ? this.state.cityId : "",
        contry: this.state.countryId ? this.state.countryId : "",
        state: this.state.stateId ? this.state.stateId : "",
        zipcode: this.state.zipcode ? this.state.zipcode : "",
        address: address,
        additional_fees_slug: this.state.additionalFees || null,
        pets: this.state.petsCount || 0,
      };

      localStorage.setItem("addressDetails", JSON.stringify(reservationData));
      localStorage.setItem("reservation_confirm", this.state.guest_slug);
      let res = await ReservationService.updateReservationData(reservationData);

      await this.getReservationDetails();
      await this.clearLocalStorage();
      resDataArr = res.data ? res.data : [];
      await this.setState({
        transactionData: resDataArr,
      });
      var unit = document.getElementById("booking-success");
      unit.click();
    } else {
    }
  };

  getReservationDetails = async () => {
    const reservationSlug = this.state.reservation_slug;
    if (!reservationSlug) {
      return;
    }

    const detailRes = await ReservationService.getReservation(reservationSlug);
    if (!global.successStatus.includes(detailRes.status)) {
      return;
    }

    const detailData = detailRes.data ? detailRes.data : {};
    if (!detailData || Object.keys(detailData).length === 0) {
      return;
    }

    const stayNights = detailData.total_stay_nights
      ? parseInt(detailData.total_stay_nights)
      : 0;
    const nightlyRate = detailData.nightly_rate
      ? parseFloat(detailData.nightly_rate)
      : 0;
    const totalNightText =
      "$" +
      nightlyRate +
      " x " +
      (stayNights > 1 ? stayNights + " nights" : "1 night");
    const totalNightlyRateDisp = "$" + nightlyRate * stayNights;

    const tripDetails = {
      ...detailData,
      total_night_text: detailData.total_night_text || totalNightText,
      total_nightly_rate_disp:
        detailData.total_nightly_rate_disp || totalNightlyRateDisp,
      nightly_rate_after_discount:
        detailData.nightly_rate_after_discount ?? detailData.nightly_rate,
      total_nightly_rate_after_discount:
        detailData.total_nightly_rate_after_discount ??
        detailData.total_nightly_rate,
    };
    await localStorage.setItem("trip_details", JSON.stringify(tripDetails));
  };

  getclientToken = async (queryString = "") => {
    this.setState({ showSpinner: true, loading: true });
    var resData = {};
    var resDataArr = [];
    var stripe_id = [];
    let inputData = {
      customer_id: this.state.customer_id,
      payment: this.getTotalWithVoucher().toFixed(2),
      guest_slug: this.state.guest_slug,
      reservation_slug: this.state.reservation_slug
        ? this.state.reservation_slug
        : "",
    };
    let res = await CmsDataService.getclientToken(inputData);
    if (global.successStatus.includes(res.status)) {
      resDataArr = res.data ? res.data[0] : [];
      stripe_id = res.data ? res.data[1] : [];
    }
    await this.setState({
      clientToken: resDataArr,
      stripe_id: stripe_id,
    });
    this.callUpdateStripeIfReady();
  };

  handleChange = (event) => {
    this.setState({ personName: event.target.value });
  };

  handleDateChange(event) {
    this.setState({ selectedDate: event.target.value });
  }

  changeHandlerPhone = (phoneNumber) => {
    this.setState({ phone_number: phoneNumber });
    if (phoneNumber.length > 8) {
      var errors = this.state.errors;
      errors.phone_number = "";
      this.setState({ errors: errors });
    }

    if (phoneNumber.length > 1) {
      var errors = this.state.errors;
      errors.phone_number = "";
      this.setState({ errors: errors });
    }
    if (phoneNumber.length > 15 || phoneNumber.length < 8) {
      var errors = this.state.errors;
      errors.phone_number = "The phone number must be a valid phone number.";
      this.setState({ errors: errors });
    }
  };

  changeHandlerCoupon = (event) => {
    var coupon_code = event.target.value;
    this.setState({ coupon_code: coupon_code });
  };

  onFocus() {
    this.setState({ type: true });
  }

  onBlur() {
    this.setState({ type: false });
  }

  checkAvailabilityDate = () => {
    var inputData = {
      listing_slug: this.state.listing_slug,
      checkin_date: this.state.startDate,
      checkout_date: this.state.endDate,
      user_token: this.state.userToken,
      level: 5,
      pets: this.state.petsCount || 0,
      additional_fees_slug: this.state.additionalFees || "",
    };
    this.getAvailibityDate(inputData);
  };

  validateDateChangeMobile = async () => {
    if (this.state.startDate === "") {
      this.setState({ openPicker: true });
    } else {
      await this.checkAvailabilityDate();
    }
    if (
      this.state.startDate !== "" &&
      (this.state.endDate === "" || this.state.endDate === null)
    ) {
      this.setState({ endDate: Moment(this.state.startDate).add(1, "days") });
    }
  };

  guestDetail = () => {
    var message = "";
    message +=
      this.state.adultCount > 1
        ? this.state.adultCount + " Guests"
        : this.state.adultCount + " Guest";
    message += this.state.childCount
      ? this.state.childCount > 1
        ? ", " + this.state.childCount + " Children"
        : ", " + this.state.childCount + " Child"
      : "";
    message += this.state.infantCount
      ? this.state.infantCount > 1
        ? ", " + this.state.infantCount + " Infants"
        : ", " + this.state.infantCount + " Infant"
      : "";
    message += this.state.petsCount
      ? this.state.petsCount > 1
        ? ", " + this.state.petsCount + " Pets"
        : ", " + this.state.petsCount + " Pet"
      : "";
    this.setState({ guestValue: message });
  };

  changeDateHandlerNewMobile = async (date) => {
    var startDate = date.value[0]
      ? Moment(date.value[0]).format("YYYY-MM-DD")
      : "";
    var endDate = date.value[1]
      ? Moment(date.value[1]).format("YYYY-MM-DD")
      : "";
    await this.setState({
      startDate: startDate,
      endDate: endDate,
      redirectToNextPage: true,
    });
    await this.checkAvailabilityDate();
  };

  changeDateHandlerNew = async (date) => {
    const startDate = date.value[0]
      ? Moment(date.value[0]).format("YYYY-MM-DD")
      : "";
    const endDate = date.value[1]
      ? Moment(date.value[1]).format("YYYY-MM-DD")
      : "";

    // Helper for weekday validation
    const isCheckAllowed = (dateStr, type) => {
      if (!dateStr) return true;
      const day = this.getWeekdayStr(dateStr);
      return this.state.weekdayRules[day]
        ? !!this.state.weekdayRules[day][type]
        : true;
    };

    if (startDate && !isCheckAllowed(startDate, "checkin")) {
      this.setState({
        message: `Check-in is not allowed on ${Moment(startDate).format(
          "dddd",
        )}`,
      });
      setTimeout(() => this.setState({ message: "" }), 5000);
      return;
    }
    if (endDate && !isCheckAllowed(endDate, "checkout")) {
      this.setState({
        message: `Check-out is not allowed on ${Moment(endDate).format(
          "dddd",
        )}`,
      });
      setTimeout(() => this.setState({ message: "" }), 5000);
      return;
    }

    // Min/Max stay validation
    if (startDate && endDate) {
      const nights = Moment(endDate).diff(Moment(startDate), "days");
      let minStay = null,
        maxStay = null,
        restrictionType = null;
      for (const rule of this.state.lorRecord) {
        if (
          Moment(startDate).isBetween(rule.from_date, rule.to_date, null, "[]")
        ) {
          minStay = rule.stays_from;
          maxStay = rule.stays_upto;
          restrictionType = rule.restriction_type;
          break;
        }
      }
      if (minStay || maxStay) {
        let valid = true;
        if (restrictionType === 1) {
          for (let d = 0; d < nights; d++) {
            const day = Moment(startDate).clone().add(d, "days");
            const rule = this.state.lorRecord.find((r) =>
              day.isBetween(r.from_date, r.to_date, null, "[]"),
            );
            if (rule) {
              if (rule.stays_from && nights < rule.stays_from) valid = false;
              if (rule.stays_upto && nights > rule.stays_upto) valid = false;
            }
          }
        } else if (restrictionType === 2) {
          if (minStay && nights < minStay) valid = false;
          if (maxStay && nights > maxStay) valid = false;
        }
        if (!valid) {
          let msg = "";
          if (minStay && nights < minStay)
            msg = `Minimum stay is ${minStay} nights.`;
          if (maxStay && nights > maxStay)
            msg = `Maximum stay is ${maxStay} nights.`;
          this.setState({ message: msg });
          setTimeout(() => this.setState({ message: "" }), 5000);
          return;
        }
      }
    }

    await this.setState({ startDate, endDate });
    await this.checkAvailabilityDate();
  };

  async getAvailibityDate(dynamicData = "") {
    this._pricingRequestId += 1;
    const requestId = this._pricingRequestId;
    this.setState({ showSpinner: true, loading: true });
    var inputData =
      dynamicData !== ""
        ? dynamicData
        : {
            listing_slug: this.state.listing_slug,
            checkin_date: this.state.startDate,
            checkout_date: this.state.endDate,
            pets: this.state.petsCount || 0,
            additional_fees_slug: this.state.additionalFees || "",
          };
    let res = await ReservationService.getAvailibityDate(inputData);
    if (requestId !== this._pricingRequestId) return;
    var availableDate = [];
    var bookedDate = [];
    var pricing = [];
    var display_main_image_property = "";
    var userToken = "";
    var message = "";
    var redirectToNextPage = false;
    // Holds server-validated addon state; rebuilt from API data on every successful response.
    var booking_addons = this.state.booking_addons;
    var apiAdditionalCost = [];
    var listing_pet_allowed = 0;
    var max_pets_allowed = 0;

    if (global.successStatus.includes(res.status)) {
      userToken = res.data && res.data.user_token ? res.data.user_token : "";
      availableDate =
        res.data && res.data.available_dates ? res.data.available_dates : [];
      bookedDate =
        res.data && res.data.reserved_dates ? res.data.reserved_dates : [];
      pricing = res.data && res.data.pricing ? res.data.pricing : {};
      display_main_image_property =
        res.data && res.data.property
          ? res.data.property.property_main_image_url
          : "";
      redirectToNextPage = res.data && res.data.pricing ? true : false;
      if (pricing) {
        localStorage.setItem("pricing", JSON.stringify(pricing));
      }
      if (this.state.startDate && this.state.endDate) {
        localStorage.setItem("checkin", this.state.startDate);
        localStorage.setItem("checkout", this.state.endDate);
      }

      // Rebuild booking_addons using API-sourced amounts to close the localStorage price-manipulation
      // vulnerability. Slugs from the URL param identify which fees are selected (safe); cost_price
      // comes exclusively from the API response (authoritative) — never from localStorage.
      apiAdditionalCost = res.data && res.data.additional_cost ? res.data.additional_cost : [];
      listing_pet_allowed = res.data && res.data.listing_pet_allowed ? parseInt(res.data.listing_pet_allowed) : 0;
      max_pets_allowed = res.data && res.data.max_pets_allowed ? parseInt(res.data.max_pets_allowed) : 0;
      var selectedSlugs = this.state.additionalFees
        ? this.state.additionalFees.split(",").map((s) => s.trim()).filter(Boolean)
        : [];
      var stayNights = pricing && pricing.nights ? parseInt(pricing.nights) || 1 : 1;
      var validatedAddonsList = apiAdditionalCost
        .filter((item) => selectedSlugs.includes(item.cost_slug)) // slug not in URL → silently excluded
        .map((item) => ({
          cost_slug: item.cost_slug,
          cost_type_name: item.cost_type_name,
          cost_price: item.cost_price, // API amount — overrides any value a guest may have set in localStorage
          fee_frequency: item.fee_frequency || "one_time",
          is_taxable: item.is_taxable ? 1 : 0,
          cost_type_id: item.cost_type_id || null,
          mandatory: item.mandatory,
        }));
      var petsCountBTP = parseInt(this.state.petsCount) || 0;
      var addonTotal = validatedAddonsList.reduce((sum, item) => {
        var base = parseFloat(item.cost_price || 0);
        var amount = item.fee_frequency === "per_night" ? base * stayNights : base;
        if (item.cost_type_name?.toLowerCase() === "pet cleaning fee") {
          amount = amount * (petsCountBTP > 0 ? petsCountBTP : 0);
        }
        return sum + amount;
      }, 0);
      booking_addons = { addon_total: addonTotal, selected_addons_list: validatedAddonsList };
      // Overwrite localStorage so CheckoutForm also receives API-sourced amounts, not guest-editable ones.
      localStorage.setItem("booking_addons", JSON.stringify(booking_addons));
    } else {
      userToken = res.data && res.data.user_token ? res.data.user_token : "";
      message = res.data && res.data.message ? res.data.message : "";
      availableDate =
        res.data && res.data.result ? res.data.result.available_dates : [];
      bookedDate =
        res.data && res.data.reserved_dates ? res.data.reserved_dates : [];
      redirectToNextPage = false;
    }
    this.setState(
      {
        availableDate: availableDate,
        bookedDate: bookedDate,
        enableDatePicker: false,
        message: message,
        pricing: pricing,
        display_main_image_property: display_main_image_property,
        redirectToNextPage: redirectToNextPage,
        booking_addons: booking_addons, // API-sourced; replaces the localStorage seed value; getTotalWithVoucher() and Stripe now use correct amounts
        additional_cost: apiAdditionalCost,
        listing_pet_allowed: listing_pet_allowed,
        max_pets_allowed: max_pets_allowed,
      },
      () => {
        this.callUpdateStripeIfReady();
        if (this.state.voucher_applied) {
          this.applyVoucher();
        }
      },
    );

    // this.UpdateStripeintent();
    this.setState({ showSpinner: false, loading: false });
  }

  UpdateStripeintent = async (queryString = "") => {
    this._stripeRequestId += 1;
    const requestId = this._stripeRequestId;
    this.setState({ stripeIntentUpdating: true });
    var resData = {};
    var resDataArr = [];
    var stripe_id = [];
    let inputData = {
      stripe_id: this.state.stripe_id,
      payment: this.getTotalWithVoucher().toFixed(2),
    };
    if (this.state.stripe_id !== "") {
      let res = await CmsDataService.updateIntent(inputData);
    }
    if (requestId !== this._stripeRequestId) return;
    this.setState({ stripeIntentUpdating: false });
  };

  normalizeAmount = (value) => {
    if (value === null || value === undefined) {
      return 0;
    }
    if (typeof value === "string") {
      return parseFloat(value.replace(/,/g, "")) || 0;
    }
    return parseFloat(value) || 0;
  };

  roundAmount = (value) => {
    return Math.round((parseFloat(value) || 0) * 100) / 100;
  };

  getDiscountedNightlyRate = () => {
    const nightly = this.normalizeAmount(this.state.pricing?.listing_price);
    const discount = this.state.voucher_applied
      ? this.normalizeAmount(this.state.voucher_discount || 0)
      : 0;
    return Math.max(0, nightly - Math.min(discount, nightly));
  };

  getTaxPercentageValue = () => {
    const raw = this.state.pricing?.taxTypePercentage;
    if (!raw) {
      return 0;
    }
    return parseFloat(String(raw).replace("%", "")) || 0;
  };

  /****

  getDiscountedTaxes = () => {
    const nightly = this.getDiscountedNightlyRate();
    const cleaning = this.normalizeAmount(this.state.pricing?.cleaning_fee);
    const percent = this.getTaxPercentageValue();
    const percentAmount = this.roundAmount(
      ((nightly + cleaning) * percent) / 100,
    );
    const dollarAmount = this.normalizeAmount(
      this.state.pricing?.tax_type_dollar,
    );
    return {
      total: this.roundAmount(percentAmount + dollarAmount),
      percentAmount: this.roundAmount(percentAmount),
      dollarAmount: this.roundAmount(dollarAmount),
    };
  };
  ***/

  getDiscountedTaxes = () => {
    const nightly = this.getDiscountedNightlyRate();
    const cleaning = this.normalizeAmount(this.state.pricing?.cleaning_fee);
    const percent = this.getTaxPercentageValue();

    const stayNights = this.state.pricing?.nights
      ? parseInt(this.state.pricing.nights, 10) || 1
      : 1;

    const petsCount = this.state.petsCount || 0;

    const taxableAddonAmount = (
      this.state.booking_addons?.selected_addons_list || []
    )
      .filter(item => item.is_taxable)
      .reduce((sum, item) => {
        const base = parseFloat(item.cost_price || 0);

        let resolvedAmount =
          item.fee_frequency === "per_night"
            ? base * stayNights
            : base;

        // Match the same calculation used by the UI
        if (
          item.cost_type_name &&
          item.cost_type_name.toLowerCase() === "pet cleaning fee"
        ) {
          resolvedAmount *= petsCount;
        }

        return sum + resolvedAmount;
      }, 0);

    const percentAmount = this.roundAmount(
      ((nightly + cleaning + taxableAddonAmount) * percent) / 100
    );

    const dollarAmount = this.normalizeAmount(
      this.state.pricing?.tax_type_dollar
    );

    return {
      total: this.roundAmount(percentAmount + dollarAmount),
      percentAmount: this.roundAmount(percentAmount),
      dollarAmount: this.roundAmount(dollarAmount),
    };
  };
  
  getDiscountedServiceFee = () => {
    const originalNightly = this.normalizeAmount(this.state.pricing?.listing_price);
    const originalServiceFee = this.normalizeAmount(this.state.pricing?.convenienceFee);
    const cleaning = this.normalizeAmount(this.state.pricing?.cleaning_fee);
    // Derive the actual service fee rate from the API values so no percentage is hardcoded
    const originalBase = cleaning > 0 ? originalNightly + cleaning : originalNightly;
    if (originalBase <= 0 || originalServiceFee <= 0) return 0;
    const rate = originalServiceFee / originalBase;
    const discountedNightly = this.getDiscountedNightlyRate();
    const discountedBase = cleaning > 0 ? discountedNightly + cleaning : discountedNightly;
    return this.roundAmount(discountedBase * rate);
  };

  getTotalWithVoucher = () => {
    const addonTotal = this.normalizeAmount(
      this.state.booking_addons && this.state.booking_addons.addon_total
        ? this.state.booking_addons.addon_total
        : 0,
    );
    if (!this.state.voucher_applied) {
      return (
        this.normalizeAmount(
          this.state.pricing?.total_listing_price_with_taxes_fees,
        ) + addonTotal
      );
    }
    const nightly = this.getDiscountedNightlyRate();
    const cleaning = this.normalizeAmount(this.state.pricing?.cleaning_fee);
    const serviceFee = this.getDiscountedServiceFee();
    const taxes = this.getDiscountedTaxes().total;
    return Math.max(0, nightly + cleaning + serviceFee + taxes) + addonTotal;
  };

  // Display-only total that excludes occupancy taxes, matching StrDetails.jsx "Total before taxes".
  // getTotalWithVoucher() is unchanged and continues to drive the Stripe payment amount.
  getTotalBeforeTaxes = () => {
    const addonTotal = this.normalizeAmount(
      this.state.booking_addons && this.state.booking_addons.addon_total
        ? this.state.booking_addons.addon_total
        : 0,
    );
    if (this.state.voucher_applied) {
      const nightly = this.getDiscountedNightlyRate();
      const cleaning = this.normalizeAmount(this.state.pricing?.cleaning_fee);
      const serviceFee = this.getDiscountedServiceFee();
      return Math.max(0, nightly + cleaning + serviceFee) + addonTotal;
    }
    return (
      this.normalizeAmount(this.state.pricing?.total_listing_price_with_taxes_fees) -
      this.normalizeAmount(this.state.pricing?.total_of_dollar_taxes) +
      addonTotal
    );
  };

  applyVoucher = async (event) => {
    if (event && event.preventDefault) {
      event.preventDefault();
    }
    const voucherCode = this.state.voucher_code
      ? this.state.voucher_code.trim()
      : "";

    if (!voucherCode) {
      this.setState({ voucher_error: "Please enter a voucher code." });
      return;
    }

    this.setState({ voucher_loading: true, voucher_error: "" });
    const bookingTotal = this.normalizeAmount(
      this.state.pricing?.listing_price,
    );
    const res = await ReservationService.applyVoucher({
      voucher_code: voucherCode,
      booking_total: bookingTotal,
      guest_slug: this.state.guest_slug ? this.state.guest_slug : null,
    });

    if (global.successStatus.includes(res.status) && res.data?.valid) {
      const discountAmount = res.data.discount_amount
        ? this.normalizeAmount(res.data.discount_amount)
        : 0;
      this.setState(
        {
          voucher_code: voucherCode,
          voucher_applied: true,
          voucher_discount: discountAmount,
          voucher_error: "",
        },
        () => {
          localStorage.setItem("applied_voucher_code", voucherCode);
          localStorage.setItem(
            "applied_voucher_discount",
            String(discountAmount),
          );
          this.callUpdateStripeIfReady();
        },
      );
    } else {
      const reason = res.data?.reason;
      this.setState({
        voucher_applied: false,
        voucher_discount: 0,
        voucher_error:
          reason === "used"
            ? "This voucher code has already been used."
            : reason === "expired"
              ? "This voucher code has expired."
              : "Invalid voucher code.",
      });
    }

    this.setState({ voucher_loading: false });
  };

  clearVoucher = () => {
    this.setState(
      {
        voucher_code: "",
        voucher_discount: 0,
        voucher_applied: false,
        voucher_error: "",
      },
      () => {
        localStorage.removeItem("applied_voucher_code");
        localStorage.removeItem("applied_voucher_discount");
        this.callUpdateStripeIfReady();
      },
    );
  };

  async incrementAdult() {
    await this.setState({
      adultCount: this.state.adultCount + 1,
      total_selected_guest: this.state.total_selected_guest + 1,
    });
    await this.guestDetail();
  }

  async decrementAdult() {
    if (this.state.adultCount === 0 || this.state.adultCount === 1) {
      await this.setState({ adultCount: 1 });
    } else {
      await this.setState({
        adultCount: this.state.adultCount - 1,
        total_selected_guest: this.state.total_selected_guest - 1,
      });
    }
    await this.guestDetail();
  }

  async incrementchild() {
    await this.setState({
      childCount: this.state.childCount + 1,
      total_selected_guest: this.state.total_selected_guest + 1,
    });
    await this.guestDetail();
  }

  async decrementchild() {
    if (this.state.childCount === 0) {
      await this.setState({ childCount: 0 });
    } else {
      await this.setState({
        childCount: this.state.childCount - 1,
        total_selected_guest: this.state.total_selected_guest - 1,
      });
    }
    await this.guestDetail();
  }

  async incrementinfant() {
    await this.setState({ infantCount: this.state.infantCount + 1 });
    await this.guestDetail();
  }

  async decrementinfant() {
    if (this.state.infantCount === 0) {
      await this.setState({ infantCount: 0 });
    } else {
      await this.setState({ infantCount: this.state.infantCount - 1 });
    }
    await this.guestDetail();
  }

  incrementpets() {
    this.setState({ petsCount: this.state.petsCount + 1, showSpinner: true, loading: true }, () => {
      this.guestDetail();
      this.syncPetFee();
    });
  }

  decrementpets() {
    if (this.state.petsCount === 0) return;
    this.setState({ petsCount: this.state.petsCount - 1, showSpinner: true, loading: true }, () => {
      this.guestDetail();
      this.syncPetFee();
    });
  }

  syncPetFee = () => {
    const { additional_cost, petsCount, additionalFees, pricing } = this.state;
    const petFeeItem = additional_cost.find(
      (item) => item.cost_type_name?.toLowerCase() === "pet fee"
    );
    const pclItem = additional_cost.find(
      (item) => item.cost_type_name?.toLowerCase() === "pet cleaning fee"
    );

    const petsSelected = petsCount > 0;
    const pclActive = pclItem
      ? parseInt(pclItem.mandatory) === 1 && petsSelected
      : false;

    const currentSlugs = additionalFees
      ? additionalFees.split(",").map((s) => s.trim()).filter(Boolean)
      : [];

    let newSlugs = [...currentSlugs];

    if (petFeeItem) {
      const petFeeSlug = petFeeItem.cost_slug;
      newSlugs = petsSelected
        ? [...new Set([...newSlugs, petFeeSlug])]
        : newSlugs.filter((s) => s !== petFeeSlug);
    }

    if (pclItem) {
      const pclSlug = pclItem.cost_slug;
      newSlugs = pclActive
        ? [...new Set([...newSlugs, pclSlug])]
        : newSlugs.filter((s) => s !== pclSlug);
    }

    const newAdditionalFees = newSlugs.join(",");

    const stayNights =
      pricing && pricing.nights ? parseInt(pricing.nights) || 1 : 1;
    const newSelectedList = additional_cost
      .filter((item) => newSlugs.includes(item.cost_slug))
      .map((item) => ({
        cost_slug: item.cost_slug,
        cost_type_name: item.cost_type_name,
        cost_price: item.cost_price,
        fee_frequency: item.fee_frequency || "one_time",
        is_taxable: item.is_taxable ? 1 : 0,
        cost_type_id: item.cost_type_id || null,
        mandatory: item.mandatory,
      }));
    const newAddonTotal = newSelectedList.reduce((sum, item) => {
      const base = parseFloat(item.cost_price || 0);
      let amount = item.fee_frequency === "per_night" ? base * stayNights : base;
      if (item.cost_type_name?.toLowerCase() === "pet cleaning fee") {
        amount = amount * (petsCount > 0 ? petsCount : 0);
      }
      return sum + amount;
    }, 0);
    const newBookingAddons = {
      addon_total: newAddonTotal,
      selected_addons_list: newSelectedList,
    };

    localStorage.setItem("booking_addons", JSON.stringify(newBookingAddons));
    this.setState(
      { additionalFees: newAdditionalFees, booking_addons: newBookingAddons },
      () => {
        clearTimeout(this._petDebounceTimer);
        this._petDebounceTimer = setTimeout(() => {
          this.checkAvailabilityDate();
        }, 400);
      }
    );
  };

  manageEditDateModal(modal = false) {
    this.setState({ editDateModal: modal, enableDatePicker: false });
  }

  manageGuestModal(modal = false) {
    this.setState({ editGuestModal: modal });
  }

  render() {
    const options = {
      // passing the client secret obtained in step 3
      clientSecret: this.state.clientToken,
      // Fully customizable with appearance API.
      appearance: {
        /*...*/
      },
    };
    const min = Moment(new Date()).format("YYYY-MM-DD");

    return (
      <main className="oh-template Brandmainpage">
        <Helmet>
          <meta name="robots" content="noindex,nofollow" />
        </Helmet>
        {/* Header */}
        <CommonHeader propertySlug={this.state.property_slug} />
        {/* middle */}
        <a
          hidden
          className="hidden"
          href={global.themeUrl + this.state.property_slug + ""}
        >
          <button id="go-to-the-home-page"></button>
        </a>
        <section className="middle">
          <div className="container-fluid p-0">
            <section className="reservationBook req_book_sec bg-white bgwhitecolor">
              <div className="container ">
                <div className="content">
                  <div className="row mobView m-0">
                    <div className="col-sm-12 col-lg-12 headingpage">
                      <div className="d-flex ResivationTitle">
                        <a href="#" className="m-0">
                          {" "}
                          <img
                            src={global.OnKeyPressEvent.getS3ImageUrl(
                              "back-arrow-icon.svg",
                            )}
                          />
                        </a>
                        <h4> Confirm and pay </h4>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 yourtrip loggedinmob">
                      <div className="requestSection">
                        <div className="row book_app_info">
                          <div className="col-12">
                            <div className="yourloggedin">
                              <img
                                src={global.OnKeyPressEvent.getS3ImageUrl(
                                  "loggedin.svg",
                                )}
                              />
                              <div className="mg-l-3">
                                <span className="pd-t-0 pd-b-0 labelTitle">
                                  Hi, you're logged in
                                </span>
                                <p>Review your booking details to continue.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-sm-12 col-md-12 col-lg-6 yourtrip">
                      <div className="requestSection loggedindesk">
                        <div className="row book_app_info">
                          <div className="col-12">
                            <div className="yourloggedin">
                              <img
                                src={global.OnKeyPressEvent.getS3ImageUrl(
                                  "loggedin.svg",
                                )}
                              />
                              <div className="mg-l-3">
                                <span className="pd-t-0 pd-b-0 labelTitle">
                                  Hi, you're logged in
                                </span>
                                <p>Review your booking details to continue.</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="requestSection">
                        <div className="row book_app_info m-0">
                          <div className="col-md-12 pd-l-0 pd-r-0 mg-b-0 d-flex- flex-column align-items-start justify-content-start first">
                            <span className="pd-t-10 pd-l-0 pd-r-0 pd-b-20 labelTitle">
                              Your trip{" "}
                            </span>

                            {this.state.message && (
                              <>
                                <p className="text-danger">
                                  {" "}
                                  {this.state.message}
                                </p>
                              </>
                            )}
                            <div className="col-md-12 pd-l-0 pd-r-0 mg-b-30 d-flex flex-row align-items-start justify-content-between">
                              <div className="w-75">
                                <strong className="d-block">Dates</strong>
                                <span className="d-block dateinputmobile">
                                  <Datepicker
                                    controls={["calendar"]}
                                    buttons={[
                                      {
                                        icon: "material-close",
                                        handler: "cancel",
                                      },
                                    ]}
                                    pages={2}
                                    calendarType="month"
                                    select="range"
                                    inputComponent="input"
                                    value={[
                                      this.state.startDate,
                                      this.state.endDate,
                                    ]}
                                    onChange={(date) =>
                                      this.changeDateHandlerNew(
                                        date,
                                        "dateFour",
                                      )
                                    }
                                    valid={this.state.availableDate}
                                    cssClass="dual_calendar"
                                    inputProps={{
                                      placeholder: "Add date",
                                    }}
                                    isOpen={this.state.openPicker}
                                    openPicker={() =>
                                      this.setState({ openPicker: true })
                                    }
                                    onLabelClick={() =>
                                      this.setState({ openPicker: true })
                                    }
                                    onInputClick={() =>
                                      this.setState({ openPicker: true })
                                    }
                                    onFocus={() =>
                                      this.setState({ openPicker: true })
                                    }
                                    onClick={() =>
                                      this.setState({ openPicker: true })
                                    }
                                    onClose={() =>
                                      this.setState({ openPicker: false })
                                    }
                                    closeOnEsc={true}
                                    defaultValue={undefined}
                                    display="center"
                                    rangeSelectMode="wizard"
                                    showRangeLabels={true}
                                    touchUi={false}
                                    theme="ios"
                                    themeVariant="light"
                                    headerText=""
                                    minRange={2}
                                    max=""
                                    min={min}
                                    inRangeInvalid={false}
                                    rangeEndInvalid={true}
                                    rangeStartLabel="Check-in"
                                    rangeEndLabel="Check-out"
                                    responsive={{
                                      xsmall: {
                                        pages: 2,
                                        touchUi: false,
                                        calendarSize: "2",
                                        calendarScroll: "horizontal",
                                        display: "anchored",
                                        refDate: Moment(new Date()).add(
                                          1,
                                          "year",
                                        ),
                                      },
                                      medium: {
                                        pages: 2,
                                        touchUi: false,
                                      },
                                    }}
                                  />
                                </span>
                              </div>
                              <p
                                className="Link"
                                onClick={() =>
                                  this.setState({ openPicker: true })
                                }
                              >
                                Edit
                              </p>
                            </div>

                            <div className="col-md-12 pd-l-0 pd-r-0 d-flex flex-row align-items-start justify-content-between guestedit">
                              <div>
                                <strong className="d-block">Guests</strong>
                                <span>{this.state.guestValue}</span>
                              </div>
                              <p
                                className="Link"
                                onClick={() => this.manageGuestModal(true)}
                              >
                                Edit
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="requestSection">
                        <div className="row book_app_info guestDetails">
                          <div className="col-12">
                            <span className="pd-t-10 pd-b-20 labelTitle">
                              Guest details
                            </span>
                          </div>
                          <div className="col-12 col-sm-12 col-md-6 col-lg-6 mg-b-30">
                            <TextField
                              id="first_name"
                              label="First name"
                              variant="outlined"
                              fullWidth
                              type="text"
                              disabled={true}
                              className="borderInput textfield"
                              name="first_name"
                              value={this.state.first_name}
                            />
                          </div>
                          <div className="col-12 col-sm-12 col-md-6 col-lg-6 mg-b-30">
                            <TextField
                              id="last_name"
                              label="Last name"
                              variant="outlined"
                              type={"text"}
                              fullWidth
                              disabled={true}
                              className="borderInput textfield"
                              name="last_name"
                              value={this.state.last_name}
                            />
                          </div>
                          <div className="col-12 col-sm-12 col-md-6 col-lg-6 mg-b-30">
                            <TextField
                              type="email"
                              id="email"
                              label="Email"
                              variant="outlined"
                              fullWidth
                              className="borderInput textfield"
                              name="email"
                              disabled={true}
                              value={this.state.email}
                            />
                          </div>
                          <div className="col-12 col-sm-12 col-md-6 col-lg-6 mg-b-30">
                            <PhoneInput
                              country={global.country}
                              className="borderInput textfield phoneInput"
                              variant="outlined"
                              id="phone_number"
                              name="phone_number"
                              value={this.state.phone_number}
                              disabled={
                                this.state.old_phone_number !== ""
                                  ? true
                                  : false
                              }
                              inputProps={{
                                id: "phoneNumberFormat",
                              }}
                              onKeyPress={
                                global.OnKeyPressEvent.phoneValidation
                              }
                              containerClass=""
                              error={
                                this.state.errors.phone_number ? true : false
                              }
                              helperText={
                                this.state.errors.phone_number
                                  ? this.state.errors.phone_number
                                  : ""
                              }
                              onChange={(e) => this.changeHandlerPhone(e)}
                            />
                            {this.state.errors.phone_number ? (
                              <p className="error-message">
                                {this.state.errors.phone_number}
                              </p>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="requestSection">
                        <div className="row book_pay_info paywith">
                          <div className="col-12 pd-l-15 pd-r-15">
                            <span className="pd-t-10 pd-b-20 labelTitle ">
                              Pay with
                            </span>
                          </div>
                          {!this.state.clientToken ? (
                            <div>
                              <h3>Loading...</h3>
                            </div>
                          ) : (
                            <div className="col-xs-12 col-sm-12 col-md-12 pd-l-15 pd-r-">
                              <Elements
                                stripe={stripePromise}
                                options={options}
                              >
                                <CheckoutForm
                                  guest_slug={this.state.guest_slug}
                                  reservation_slug={
                                    this.state.reservation_slug
                                      ? this.state.reservation_slug
                                      : ""
                                  }
                                  street_address_1={
                                    this.state.street_address_1
                                      ? this.state.street_address_1
                                      : ""
                                  }
                                  phone_number={this.state.phone_number}
                                  street_address_2={
                                    this.state.street_address_2
                                      ? this.state.street_address_2
                                      : ""
                                  }
                                  city={this.state.city ? this.state.city : ""}
                                  contry={
                                    this.state.country ? this.state.country : ""
                                  }
                                  state={
                                    this.state.state ? this.state.state : ""
                                  }
                                  zipcode={
                                    this.state.zipcode ? this.state.zipcode : ""
                                  }
                                  address={this.state.address}
                                  stripe_id={this.state.stripe_id}
                                  countryId={this.state.countryId}
                                  stateId={this.state.stateId}
                                  cityId={this.state.cityId}
                                  startDate={this.state.startDate}
                                  endDate={this.state.endDate}
                                  propertySlug={this.state.property_slug}
                                  confirmation_code={
                                    this.state.confirmation_code
                                  }
                                  voucher_code={
                                    this.state.voucher_applied
                                      ? this.state.voucher_code
                                      : ""
                                  }
                                  voucher_discount={
                                    this.state.voucher_applied
                                      ? this.state.voucher_discount
                                      : 0
                                  }
                                  adults={this.state.adultCount}
                                  children={this.state.childCount}
                                  infants={this.state.infantCount}
                                  last_name={
                                    this.state.last_name
                                      ? this.state.last_name
                                      : this.state.userData.last_name
                                  }
                                  listing_slug={this.state.listing_slug}
                                  total_selected_guest={
                                    this.state.total_selected_guest
                                  }
                                  redirectToNextPage={
                                    this.state.redirectToNextPage
                                  }
                                  user_token={this.state.userToken}
                                  payment={this.getTotalWithVoucher().toFixed(
                                    2,
                                  )}
                                  validationErrorsHandler={this.setErrorFromCheckout.bind(
                                    this,
                                  )}
                                  pets={this.state.petsCount}
                                  additionalFees={this.state.additionalFees}
                                  pricingLoading={
                                    this.state.showSpinner ||
                                    this.state.loading ||
                                    !!this.state.stripeIntentUpdating
                                  }
                                />
                              </Elements>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-1 col-xl-1"></div>
                    {this.state.redirectToNextPage === true ? (
                      <div className="col-12 col-sm-12 col-md-12 col-lg-5 col-xl-5 position-relative priceDetail">
                        <div className="requestaddedSection m-0">
                          <figure>
                            <img
                              src={
                                this.state.pricing
                                  ? this.state.pricing.listing_image
                                    ? this.state.pricing.listing_image
                                        .large_img_w_720
                                    : this.state.display_main_image_property
                                  : this.state.display_main_image_property
                              }
                              className="img-fluid"
                              alt="Property Logo"
                              title="Property Logo"
                            />
                          </figure>
                          <div className="priceInfo">
                            <div className="priceTop">
                              <h5>
                                {this.state.pricing.listing_name
                                  ? this.state.pricing.listing_name
                                  : this.state.property_name
                                    ? this.state.property_name
                                    : ""}
                              </h5>
                            </div>
                            <div className="priceMiddle">
                              <span className="mg-b-20 d-block">
                                Price details
                              </span>
                              <ul>
                                {(() => {
                                  const nights = this.state.pricing.nights
                                    ? this.state.pricing.nights
                                    : 1;
                                  const nightlyTotal = this.normalizeAmount(
                                    this.state.pricing.listing_price,
                                  );
                                  const nightlyRate =
                                    nights > 0 ? nightlyTotal / nights : 0;
                                  const discount = this.state.voucher_applied
                                    ? this.normalizeAmount(
                                        this.state.voucher_discount || 0,
                                      )
                                    : 0;
                                  const discountedNightly = this.state
                                    .voucher_applied
                                    ? this.getDiscountedNightlyRate()
                                    : nightlyTotal;
                                  const nightLabel =
                                    nights > 1 ? " nights" : " night";

                                  return (
                                    <>
                                      <li>
                                        <span>
                                          {`$${global.OnKeyPressEvent.numberWithCommasForDecimal(
                                            parseFloat(nightlyRate)
                                              .toFixed(2)
                                              .replace(/\.00$/, ""),
                                          )}  × ${nights}${nightLabel}`}
                                        </span>
                                        <span
                                          style={
                                            this.state.voucher_applied
                                              ? {
                                                  color: "#9aa0a6",
                                                  textDecoration:
                                                    "line-through",
                                                }
                                              : {}
                                          }
                                        >
                                          {`$${global.OnKeyPressEvent.numberWithCommasForDecimal(
                                            parseFloat(nightlyTotal)
                                              .toFixed(2)
                                              .replace(/\.00$/, ""),
                                          )}`}
                                        </span>
                                      </li>
                                      {this.state.voucher_applied ? (
                                        <li>
                                          <span>
                                            {`$${global.OnKeyPressEvent.numberWithCommasForDecimal(
                                              parseFloat(nightlyRate)
                                                .toFixed(2)
                                                .replace(/\.00$/, ""),
                                            )}  × ${nights}${nightLabel} - $${global.OnKeyPressEvent.numberWithCommasForDecimal(
                                              parseFloat(discount)
                                                .toFixed(2)
                                                .replace(/\.00$/, ""),
                                            )}`}{" "}
                                            <span
                                              className="badge badge-success ml-2"
                                              style={{ fontSize: "11px" }}
                                            >
                                              Applied
                                            </span>
                                          </span>
                                          <span>{`$${global.OnKeyPressEvent.numberWithCommasForDecimal(
                                            parseFloat(discountedNightly)
                                              .toFixed(2)
                                              .replace(/\.00$/, ""),
                                          )}`}</span>
                                        </li>
                                      ) : null}
                                    </>
                                  );
                                })()}

                                {this.state.booking_addons &&
                                  this.state.booking_addons.selected_addons_list &&
                                  this.state.booking_addons.selected_addons_list.length > 0
                                  ? this.state.booking_addons.selected_addons_list.map((addon, i) => {
                                      const nights = this.state.pricing && this.state.pricing.nights
                                        ? parseInt(this.state.pricing.nights) : 1;
                                      const petsCount = this.state.petsCount || 0;
                                      const baseAmount = parseFloat(addon.cost_price || 0);
                                      let resolvedAmount = addon.fee_frequency === "per_night"
                                        ? baseAmount * nights : baseAmount;
                                      let displayName = addon.fee_frequency === "per_night"
                                        ? (addon.cost_type_name || "Additional Service") + " × " + nights + " night" + (nights > 1 ? "s" : "")
                                        : (addon.cost_type_name || "Additional Service");
                                      if (addon.cost_type_name?.toLowerCase() === "pet cleaning fee") {
                                        resolvedAmount = resolvedAmount * petsCount;
                                        displayName = addon.fee_frequency === "per_night"
                                          ? "Pet Cleaning Fee × " + petsCount + " pet" + (petsCount !== 1 ? "s" : "") + " × " + nights + " night" + (nights > 1 ? "s" : "")
                                          : "Pet Cleaning Fee × " + petsCount + " pet" + (petsCount !== 1 ? "s" : "");
                                      }
                                      return (
                                        <li key={i}>
                                          <span>{displayName}</span>
                                          <span>{`$${global.OnKeyPressEvent.numberWithCommasForDecimal(
                                            resolvedAmount.toFixed(2).replace(/\.00$/, ""),
                                          )}`}</span>
                                        </li>
                                      );
                                    })
                                  : ""}

                                {this.state.pricing ? (
                                  this.state.pricing.cleaning_fee &&
                                  this.state.pricing.cleaning_fee !== "0.00" ? (
                                    <li>
                                      <span>Cleaning fee</span>
                                      <span>{`$${
                                        this.state.pricing.cleaning_fee
                                          ? global.OnKeyPressEvent.numberWithCommasForDecimal(
                                              parseFloat(
                                                this.state.pricing.cleaning_fee,
                                              )
                                                .toFixed(2)
                                                .replace(/\.00$/, ""),
                                            )
                                          : parseInt(0).toFixed(2)
                                      }`}</span>
                                    </li>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                                {this.state.pricing && this.state.pricing.convenienceFee > 0 ? (
                                <li>
                                  <span>Service fees</span>
                                  <span>{`$${
                                    (
                                      this.state.voucher_applied
                                        ? this.getDiscountedServiceFee()
                                        : this.state.pricing.convenienceFee
                                    )
                                      ? global.OnKeyPressEvent.numberWithCommasForDecimal(
                                          parseFloat(
                                            this.state.voucher_applied
                                              ? this.getDiscountedServiceFee()
                                              : this.state.pricing
                                                  .convenienceFee,
                                          )
                                            .toFixed(2)
                                            .replace(/\.00$/, ""),
                                        )
                                      : parseInt(0).toFixed(2)
                                  }`}</span>
                                </li>
                                ) : ""}

                                {this.state.pricing ? (
                                  (
                                    this.state.voucher_applied
                                      ? this.getDiscountedTaxes().total
                                      : this.state.pricing.total_of_dollar_taxes
                                  ) ? (
                                    <li>
                                      <span>Occupancy taxes</span>
                                      <span>{`$${
                                        (
                                          this.state.voucher_applied
                                            ? this.getDiscountedTaxes().total
                                            : this.state.pricing
                                                .total_of_dollar_taxes
                                        )
                                          ? global.OnKeyPressEvent.numberWithCommasForDecimal(
                                              parseFloat(
                                                this.state.voucher_applied
                                                  ? this.getDiscountedTaxes()
                                                      .total
                                                  : this.state.pricing
                                                      .total_of_dollar_taxes,
                                              )
                                                .toFixed(2)
                                                .replace(/\.00$/, ""),
                                            )
                                          : parseInt(0).toFixed(2)
                                      }`}</span>
                                    </li>
                                  ) : (
                                    ""
                                  )
                                ) : (
                                  ""
                                )}
                                {this.state.voucher_applied ? (
                                  <li>
                                    <span>Voucher discount</span>
                                    <span className="text-success">{`-$${global.OnKeyPressEvent.numberWithCommasForDecimal(
                                      this.normalizeAmount(
                                        this.state.voucher_discount,
                                      )
                                        .toFixed(2)
                                        .replace(/\.00$/, ""),
                                    )}`}</span>
                                  </li>
                                ) : (
                                  ""
                                )}
                              </ul>
                              <div className="mg-t-15">
                                <label className="mg-b-5 d-block">
                                  Voucher Code
                                </label>
                                <div className="input-group">
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={this.state.voucher_code || ""}
                                    onChange={(event) =>
                                      this.setState({
                                        voucher_code: event.target.value,
                                        voucher_error: "",
                                      })
                                    }
                                    disabled={this.state.voucher_applied}
                                  />
                                  <div className="input-group-append">
                                    {this.state.voucher_applied ? (
                                      <button
                                        className="book-btn"
                                        type="button"
                                        onClick={this.clearVoucher}
                                      >
                                        Remove
                                      </button>
                                    ) : (
                                      <button
                                        className="book-btn"
                                        type="button"
                                        onClick={this.applyVoucher}
                                        disabled={this.state.voucher_loading}
                                      >
                                        Apply
                                      </button>
                                    )}
                                  </div>
                                </div>
                                {this.state.voucher_error ? (
                                  <div className="text-danger">
                                    {this.state.voucher_error}
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                            <div className="priceBottom">
                              <ul>
                                <li>
                                  <span>Total (USD)</span>
                                  <b>
                                    <span>{`$${global.OnKeyPressEvent.numberWithCommasForDecimal(
                                      this.getTotalWithVoucher()
                                        .toFixed(2)
                                        .replace(/\.00$/, ""),
                                    )}`}</span>
                                  </b>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>

        <Modal
          show={this.state.editGuestModal}
          centered
          onHide={() => this.manageGuestModal(false)}
          className="guestModalbox"
        >
          <Modal.Body className="width_402 p-4 border_radius_14">
            <span
              className="welcomeClose float-end"
              onClick={() => this.manageGuestModal(false)}
            >
              {global.closee}
            </span>
            <div className="dropmenuInputbox">
              <h4>Guests</h4>

              <div className="dropdown-item">
                <div className="d-flex justify-content-between align-items-start mg-t-15 mg-t-15">
                  <ul>
                    <li>
                      <strong>Adults</strong>
                      <span>Age 13+</span>
                    </li>
                  </ul>
                  <div className="d-flex align-items-center countBtn">
                    <span>
                      <button
                        onClick={this.decrementAdult}
                        disabled={this.state.adultCount === 1 ? true : false}
                      >
                        <img
                          src={global.OnKeyPressEvent.getS3ImageUrl(
                            "minus-icon.svg",
                          )}
                          alt="Guest Count"
                          title="Guest Count"
                        />
                      </button>
                    </span>
                    <span> {this.state.adultCount}</span>
                    <span>
                      <button
                        onClick={this.incrementAdult}
                        disabled={
                          parseInt(this.state.guest) ===
                          this.state.total_selected_guest
                            ? true
                            : false
                        }
                      >
                        <img
                          src={global.OnKeyPressEvent.getS3ImageUrl(
                            "add-icon.svg",
                          )}
                          alt="Guest Count"
                          title="Guest Count"
                        />
                      </button>
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-start mg-t-15 mg-t-15">
                  <ul>
                    <li>
                      <strong>Children</strong>
                      <span>Ages 2–12</span>
                    </li>
                  </ul>
                  <div className="d-flex align-items-center countBtn">
                    <span>
                      <button
                        onClick={this.decrementchild}
                        disabled={this.state.childCount === 0 ? true : false}
                      >
                        <img
                          src={global.OnKeyPressEvent.getS3ImageUrl(
                            "minus-icon.svg",
                          )}
                          alt="Guest Count"
                          title="Guest Count"
                        />
                      </button>
                    </span>
                    <span>{this.state.childCount}</span>
                    <span>
                      <button
                        onClick={this.incrementchild}
                        disabled={
                          parseInt(this.state.guest) ===
                          this.state.total_selected_guest
                            ? true
                            : false
                        }
                      >
                        <img
                          src={global.OnKeyPressEvent.getS3ImageUrl(
                            "add-icon.svg",
                          )}
                          alt="Guest Count"
                          title="Guest Count"
                        />
                      </button>
                    </span>
                  </div>
                </div>
                <div className="d-flex justify-content-between align-items-start mg-t-15 mg-t-15">
                  <ul>
                    <li>
                      <strong>Infants</strong>
                      <span>Under 2</span>
                    </li>
                  </ul>
                  <div className="d-flex align-items-center countBtn">
                    <span>
                      <button
                        onClick={this.decrementinfant}
                        disabled={this.state.infantCount === 0 ? true : false}
                      >
                        <img
                          src={global.OnKeyPressEvent.getS3ImageUrl(
                            "minus-icon.svg",
                          )}
                          alt="Guest Count"
                          title="Guest Count"
                        />
                      </button>
                    </span>
                    <span> {this.state.infantCount}</span>
                    <span>
                      <button
                        onClick={this.incrementinfant}
                        disabled={this.state.infantCount === 5 ? true : false}
                      >
                        <img
                          src={global.OnKeyPressEvent.getS3ImageUrl(
                            "add-icon.svg",
                          )}
                          alt="Guest Count"
                          title="Guest Count"
                        />
                      </button>
                    </span>
                  </div>
                </div>

                {this.state.listing_pet_allowed === 1 &&
                  this.state.max_pets_allowed > 0 && (
                  <div className="d-flex justify-content-between align-items-start mg-t-15 mg-t-15">
                    <ul>
                      <li>
                        <strong>Pets</strong>
                      </li>
                    </ul>
                    <div className="d-flex align-items-center countBtn">
                      <span>
                        <button
                          onClick={this.decrementpets}
                          disabled={this.state.petsCount === 0 ? true : false}
                        >
                          <img
                            src={global.OnKeyPressEvent.getS3ImageUrl(
                              "minus-icon.svg",
                            )}
                            alt="Pet Count"
                            title="Pet Count"
                          />
                        </button>
                      </span>
                      <span> {this.state.petsCount}</span>
                      <span>
                        <button
                          onClick={this.incrementpets}
                          disabled={
                            this.state.petsCount >= this.state.max_pets_allowed
                              ? true
                              : false
                          }
                        >
                          <img
                            src={global.OnKeyPressEvent.getS3ImageUrl(
                              "add-icon.svg",
                            )}
                            alt="Pet Count"
                            title="Pet Count"
                          />
                        </button>
                      </span>
                    </div>
                  </div>
                )}
                <div className="d-flex justify-content-end">
                  <button
                    className="done"
                    id="cnt-close"
                    onClick={() => this.manageGuestModal(false)}
                  >
                    Save
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <Modal
          show={this.state.cancelModal}
          centered
          onHide={() => this.setState({ cancelModal: false })}
          className="reservationDetailmodalbox"
        >
          <span
            className="welcomeClose"
            onClick={() => this.setState({ cancelModal: false })}
          >
            {global.closee}
          </span>

          <Modal.Body className="width_402 p-4 border_radius_14">
            <div className="reservationDetails">
              <h6>Cancellation policy for your listing</h6>
              <ul>
                <li>
                  To receive a full refund, you must cancel within 48 hours of
                  booking, and the cancellation must occur at least 14 days
                  before check-in
                </li>
                <li>
                  If you cancel between 7 and 14 days before check-in, you’ll be
                  paid 50% for all nights
                </li>
                <li>
                  If you cancel after that, you’ll be paid 100% for all nights
                </li>
              </ul>
            </div>
          </Modal.Body>
        </Modal>
        {/* Footer */}

        <CommonFooter showSubscribe={true} showFooterBottom={false} />
        <footer className="footer-nav-sec pt-80">
          <CommonFooterNav />
        </footer>
        <CommonFooter showSubscribe={false} showFooterBottom={true} />
      </main>
    );
  }
}
export default BookTourPayment;
